import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  service_order: yup.string().required(),
});
